import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";

import { AddTalentReviewCandidate } from "../../../types/addReviewCandidate";

import RatingTable from "../RatingTable";

const MindsetPsychologicalStep = () => {
  const { t } = useTranslation("goHire", { keyPrefix: "components.reviewCandidateModal" });
  const { t: tTalentReport } = useTranslation("goHire", { keyPrefix: "components.reviewCandidateModal.talentReport" });

  const { control } = useFormContext<AddTalentReviewCandidate>();

  const skills: { title: string; description: string; fieldName: keyof AddTalentReviewCandidate }[] = [
    {
      title: tTalentReport("concentration"),
      description: tTalentReport("focusAndAlertness"),
      fieldName: "concentration",
    },
    { title: tTalentReport("confidence"), description: tTalentReport("selfBeliefInActions"), fieldName: "confidence" },
    {
      title: tTalentReport("leadership"),
      description: tTalentReport("abilityToGuideMotivateOrganize"),
      fieldName: "leadership",
    },
    {
      title: tTalentReport("discipline"),
      description: tTalentReport("respectForRulesCoaches"),
      fieldName: "discipline",
    },
    { title: tTalentReport("workRate"), description: tTalentReport("effortAndCommitment"), fieldName: "workRate" },
    { title: tTalentReport("resilience"), description: tTalentReport("abilityToRecover"), fieldName: "resilience" },
    { title: tTalentReport("coachAbility"), description: tTalentReport("abilityToRecover"), fieldName: "coachAbility" },
    {
      title: tTalentReport("professionalism"),
      description: tTalentReport("consistentTrainingHabits"),
      fieldName: "professionalism",
    },
  ];

  return (
    <Box sx={[styles.container, styles.containerPadding]}>
      <RatingTable ratings={skills} control={control} />
    </Box>
  );
};

export default MindsetPsychologicalStep;

const styles = {
  containerPadding: {
    px: "24px",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
};
